module.exports = __webpack_public_path__ + "img/app_store2.a2bd35be.png";